import { AnswerTypeEnum } from "../enums/answerTypeEnums";

export const isMultiSelectScale = (scaleName: string): boolean =>
  scaleName === AnswerTypeEnum.VRIDDHI;

export const serializeAnswer = (selectedUrls: string[]): string =>
  JSON.stringify(selectedUrls);

export const parseAnswer = (answer: string): string[] => {
  if (!answer) return [answer];
  if (answer.startsWith("[")) {
    try {
      const parsed = JSON.parse(answer);
      return Array.isArray(parsed) ? parsed : [answer];
    } catch {
      return [answer];
    }
  }
  return [answer];
};
